import React, { useState } from 'react';
import { Button } from '../ui/button';
import {
  HelpCircle, LayoutDashboard, FileText, ClipboardList, Truck, Users, Briefcase,
  Calendar, CalendarDays, Building2, Package, Boxes, Landmark, TrendingUp, Calculator,
  Upload, FileSignature, Palette, BarChart3, Receipt, Plus, CheckCircle2, Sparkles,
  AlertTriangle, Clock, FolderKanban,
} from 'lucide-react';
import HelpInfoDialog from './HelpInfoDialog';
import HELP from './HelpRegistry';

// Map of icon names (strings) used in HelpRegistry → real lucide components.
const ICONS = {
  HelpCircle, LayoutDashboard, FileText, ClipboardList, Truck, Users, Briefcase,
  Calendar, CalendarDays, Building2, Package, Boxes, Landmark, TrendingUp, Calculator,
  Upload, FileSignature, Palette, BarChart3, Receipt, Plus, CheckCircle2, Sparkles,
  AlertTriangle, Clock, FolderKanban,
};

const resolveIcon = (name) => ICONS[name] || HelpCircle;

/**
 * Drop-in help button. Add anywhere in a page header with:
 *   <PageHelpButton moduleKey="invoices" />
 *
 * If the moduleKey is missing in the registry, the button is hidden.
 * Variants:
 *   - default (full button with "¿Qué es esto?" text)
 *   - icon (small icon-only round button — useful in tight headers)
 */
const PageHelpButton = ({ moduleKey, variant = 'default', className = '' }) => {
  const [open, setOpen] = useState(false);
  const entry = HELP[moduleKey];
  if (!entry) return null;

  const titleIcon = resolveIcon(entry.icon);
  const sections = (entry.sections || []).map(s => ({ ...s, icon: resolveIcon(s.icon) }));

  if (variant === 'icon') {
    return (
      <>
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="¿Qué es esto?"
          title="¿Qué es esto?"
          className={`w-9 h-9 rounded-full border border-violet-200 text-violet-700 hover:bg-violet-50 flex items-center justify-center transition-colors ${className}`}
          data-testid={`help-btn-${moduleKey}`}
        >
          <HelpCircle className="w-4 h-4" />
        </button>
        <HelpInfoDialog
          open={open}
          onClose={() => setOpen(false)}
          icon={titleIcon}
          title={entry.title}
          intro={<div dangerouslySetInnerHTML={{ __html: entry.intro }} />}
          sections={sections}
        />
      </>
    );
  }

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className={`rounded-full border-violet-200 text-violet-700 hover:bg-violet-50 ${className}`}
        data-testid={`help-btn-${moduleKey}`}
      >
        <HelpCircle className="w-4 h-4 mr-1.5" />
        ¿Qué es esto?
      </Button>
      <HelpInfoDialog
        open={open}
        onClose={() => setOpen(false)}
        icon={titleIcon}
        title={entry.title}
        intro={<div dangerouslySetInnerHTML={{ __html: entry.intro }} />}
        sections={sections}
      />
    </>
  );
};

export default PageHelpButton;
